'use strict';exports.__esModule = true;exports.sendProfessionalsContactUsForm = exports.closeProfessionalsContactModal = exports.openProfessionalsContactModal = exports.changeProfessionalsSliderActiveIdx = exports.clearProfessionals = exports.receiveProfessionals = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var

promise = _reduxLoop.Effects.promise;

var receiveProfessionals = (0, _reduxAct.createAction)('/RECEIVE_PROFESSIONALS');
var receiveProfessionalsSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROFESSIONALS_SUCCESS');
var receiveProfessionalsFail = (0, _reduxAct.createAction)('/RECEIVE_PROFESSIONALS_FAIL');
var changeProfessionalsSliderActiveIdx = (0, _reduxAct.createAction)('/CHANGE_PROFESSIONALS_SLIDER_ACTIVE_IDX');
var clearProfessionals = (0, _reduxAct.createAction)('/CLEAR_PROFESSIONALS');
var openProfessionalsContactModal = (0, _reduxAct.createAction)('/OPEN_PROFESSIONALS_CONTACT_MODAL');
var closeProfessionalsContactModal = (0, _reduxAct.createAction)('/CLOSE_PROFESSIONALS_CONTACT_MODAL');
var sendProfessionalsContactUsForm = (0, _reduxAct.createAction)('/SEND_PROFESSIONALS_CONTACT_US');
var sendProfessionalsContactUsFormSuccess = (0, _reduxAct.createAction)('/SEND_PROFESSIONALS_CONTACT_US_SUCCESS');
var sendProfessionalsContactUsFormFail = (0, _reduxAct.createAction)('/SEND_COMPANY_PROFESSIONALS_US_FAIL');

var initialState = {
  loading: false,
  loaded: false,
  activeSlideIdx: 0,
  professionals: [],
  professionalsCount: 0,
  formError: null,
  formSubmitting: false,
  formSubmitted: false,
  professionalContactFormIsOpen: false };


var receiveHandlerSuccess = function receiveHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    professionals: state.skip === 0 ? response.data.data : [].concat(state.professionals, response.data.data),
    professionalsCount: (0, _get2.default)(response, 'data.meta.total') });};


var receiveHandlerFail = function receiveHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading pofessionals');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error,
    professionals: [],
    professionalsCount: 0 });

};

var fetchReceive = function fetchReceive(params) {return _axios2.default.get('/agencies/public', {
    params: params && Object.assign({},
    params, {
      type: params.type === 'all' ? undefined : params.type }) }).


  then(receiveProfessionalsSuccess, receiveProfessionalsFail);};

var submitProfessionalsContactUsForm = function submitProfessionalsContactUsForm(data) {var
  isCompanyByOwner = data.isCompanyByOwner,newData = _objectWithoutProperties(data, ['isCompanyByOwner']);

  return _axios2.default.
  post('mailing/contact_us_professional' + (isCompanyByOwner ? '_auto' : ''), newData).
  then(sendProfessionalsContactUsFormSuccess, sendProfessionalsContactUsFormFail);
};

var receiveHandler = function receiveHandler(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    skip: params && params.$skip ? params.$skip : 0 }),
  promise(fetchReceive, params));};

var changeSliderIdx = function changeSliderIdx(state, idx) {return Object.assign({}, state, { activeSlideIdx: idx });};

var handleClearProfessionals = function handleClearProfessionals(state) {return Object.assign({}, state, { professionals: [] });};

var handleOpenProfessionalsContactModal = function handleOpenProfessionalsContactModal(state) {return Object.assign({},
  state, {
    professionalContactFormIsOpen: true });};


var handleCloseProfessionalsContactModal = function handleCloseProfessionalsContactModal(state) {return Object.assign({},
  state, {
    professionalContactFormIsOpen: false });};


var handleSendProfessionalsContactUsForm = function handleSendProfessionalsContactUsForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitting: true }),
  promise(submitProfessionalsContactUsForm, action));};

var handleSendProfessionalsContactUsFormSuccess = function handleSendProfessionalsContactUsFormSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null });};


var handleSendProfessionalsContactUsFormFail = function handleSendProfessionalsContactUsFormFail(state, _ref) {var response = _ref.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};


var professionals = (0, _reduxAct.createReducer)(function (on) {
  on(receiveProfessionals, receiveHandler);
  on(receiveProfessionalsSuccess, receiveHandlerSuccess);
  on(receiveProfessionalsFail, receiveHandlerFail);
  on(changeProfessionalsSliderActiveIdx, changeSliderIdx);
  on(clearProfessionals, handleClearProfessionals);
  on(openProfessionalsContactModal, handleOpenProfessionalsContactModal);
  on(closeProfessionalsContactModal, handleCloseProfessionalsContactModal);
  on(sendProfessionalsContactUsForm, handleSendProfessionalsContactUsForm);
  on(sendProfessionalsContactUsFormSuccess, handleSendProfessionalsContactUsFormSuccess);
  on(sendProfessionalsContactUsFormFail, handleSendProfessionalsContactUsFormFail);
}, initialState);exports.


receiveProfessionals = receiveProfessionals;exports.
clearProfessionals = clearProfessionals;exports.
changeProfessionalsSliderActiveIdx = changeProfessionalsSliderActiveIdx;exports.
openProfessionalsContactModal = openProfessionalsContactModal;exports.
closeProfessionalsContactModal = closeProfessionalsContactModal;exports.
sendProfessionalsContactUsForm = sendProfessionalsContactUsForm;exports.default =


professionals;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/professionals.js
// module id = 394
// module chunks = 0